import React from 'react';

import BackLink from 'components/BackLink/BackLink';
import { AppsList } from 'components/AppsList/AppsList';

import { type App } from 'generated/graphql';
import { getConnectUrl } from 'utils';
import styles from './NoMenus.module.scss';

interface Props {
  apps: App[];
  isAbout?: boolean;
  venueId?: string;
}

export const Hero: React.FC<Props> = ({ apps, isAbout, venueId }) => {
  const getAppUrl = (app: App): string => {
    return getConnectUrl(venueId, `apps/${app.id}`);
  };

  return (
    <section aria-labelledby="hero-title" className={styles.Hero}>
      <div className={`${styles.Cont} container`}>
        <div className={`${styles.Main} ${isAbout ? styles.About : ''}`}>
          {isAbout && (
            <div className={styles.BackLink} data-testid="hero-backlink">
              <BackLink textColour="white" title="Back to menus" />
            </div>
          )}
          <h1 id="hero-title">A single place to manage your menus.</h1>
          <div>
            Save time by managing your menus for a range of supported Pickup & Delivery and In-Venue Ordering apps with
            Doshii.
          </div>
          <div className={styles.Apps}>
            <div>Supported apps</div>
            <AppsList getUrl={getAppUrl} apps={apps} />
          </div>
          <a href={getConnectUrl(venueId, 'apps')} className="button light">
            Connect an app
          </a>
        </div>
        <div className={styles.Image}>
          <img src="/Images/nomenus-hero.png" alt="Dashboard" />
        </div>
      </div>
    </section>
  );
};

export default Hero;
